import { Tab, Tabs } from 'react-bootstrap';
import TicketGroupMap from 'modules/ticket_groups/TicketGroupMap';
import SubcategoryGroupMapping from 'modules/ticket_groups/SubcategoryGroupMapping';
import { useTicketGroups } from './store';
import { useEffect, useState } from 'react';
import TicketGroupLogs from 'modules/ticket_groups/TicketGroupLogs';

const TicketGroups = () => {
    const {fetchAllGroups, groups} = useTicketGroups();
    useEffect(()=>{
        fetchAllGroups();
    },[])
    const [assigneeGroups, setAssigneeGroups] = useState([]);
    useEffect(()=>{
        setAssigneeGroups(Object.entries(groups));
    },[groups])
    

    return (
        <div className='bg-white p-3'>
            <Tabs variant='pills' defaultActiveKey="subcategories" id="uncontrolled-tab-example" className='mb-3'>
                <Tab eventKey="subcategories" title="Subcategories" className='border p-3'>
                <SubcategoryGroupMapping assigneeGroups={assigneeGroups}/>
                </Tab>
                <Tab eventKey="groups" title="Groups" className='border p-3'>
                    <TicketGroupMap assigneeGroups={assigneeGroups}/>
                </Tab>
                <Tab eventKey="groupslogs" title="Groups Activity Logs" className='border p-3'>
                    <TicketGroupLogs />
                </Tab>
            </Tabs>
        </div>
    )
}

export default TicketGroups;